module.exports = __webpack_public_path__ + "img/article_ad_banner_05.672693c6.jpg";